<template>
    <FormModal :model="model" :init="init" modal-id="shipping_box">
        <template>
            <div :key="key" class="d-flex">
                <b-badge
                    :variant="$store.getters['user/level2variant'](model.level)"
                    class="align-self-center mr-1"
                    >
                    {{
                    trans.labels[
                    'users.level.' + model.level
                    ]
                    }}
                </b-badge>
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_edit_mode">
                <b-form-group
                    label-cols-sm="2"
                    label=""
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-checkbox
                        v-model="model.is_default"
                        :value="1"
                        :unchecked-value="0"
                        >
                        初期値として利用する
                    </b-form-checkbox>
                    <input-error :errors="error.is_default" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="保存名"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.name"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.name" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="縦cm"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.depth"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.depth" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="横cm"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.width"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.width" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="高さcm"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.height"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.height" />
                </b-form-group>

                <b-form-group
                    label-cols-sm="2"
                    label="重量kg"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.weight"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.weight" />
                </b-form-group>
            </template>
            <template v-else>
            </template>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import InputError from '@/components/InputError.vue'
import AddressContent from '@/components/AddressContent.vue'
import SelectCountry from '@/components/SelectCountry.vue'

export default {
    components: {
        FormModal,
        AddressContent,
        SelectCountry,
        InputError,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>


